import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes'
import { useAuthStore } from '@/stores/auth'

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Auth guard. Если меню требует auth и пользователь не загружен — загрузим,
// и если всё ещё неавторизован — выкинем на /auth/login с redirect-параметром.
router.beforeEach(async (to) => {
  const auth = useAuthStore()
  if (!auth.loaded) await auth.loadMe()

  if (to.meta.auth && !auth.isAuthenticated) {
    return { name: 'login', query: { next: to.fullPath } }
  }
  if (to.name === 'login' && auth.isAuthenticated) {
    return { name: 'dashboard' }
  }
})

// Глобальный 401 от axios → редиректим на login. Но если уже на login
// (например 401 mfa_required при входе) — не трогаем: иначе next=/login и после
// успешного входа редирект зациклится обратно на login. [#5]
window.addEventListener('bx:unauthorized', () => {
  if (router.currentRoute.value.name === 'login') return
  const next = router.currentRoute.value.fullPath
  router.push({ name: 'login', query: { next } }).catch(() => {})
})
